var getValidName = (value) => {
    let val = value
    //var alsp = /^[a-zA-Z\''\-\s.]*$/i;
    if(value && value != '' && value != null){
        val = value.replace(/[^a-zA-Z\''\-\s.]/g, '');
    }
    return val;
};


var nameValidations = {};
nameValidations.getValidName = getValidName;

window.nameValidations = nameValidations;

export default nameValidations;



// WEBPACK FOOTER //
// ./src/components/Core/namevalidation.js